(function () {
  "use strict";
  if (window.Shopify && window.Shopify.designMode) return;

  var pixelId = "2560717111079836";
  var pendingKey = "ufs_meta_pending_inquiry_v1";
  var initialized = false;
  var pageViewSent = false;

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && navigator.globalPrivacyControl !== true &&
        privacy.marketingAllowed() && privacy.saleOfDataAllowed();
    } catch (error) {
      return false;
    }
  }

  function recordInquirySubmission(event) {
    var form = event.target;
    if (!allowed() || !form || form.id !== "ContactForm") return;
    try {
      sessionStorage.setItem(pendingKey, JSON.stringify({
        id: "ufs-inquiry-" + crypto.randomUUID(),
        path: location.pathname,
        expires: Date.now() + 30 * 60 * 1000
      }));
    } catch (error) {
      return;
    }
  }

  function sendCompletedInquiry() {
    if (!allowed() || !document.querySelector("[data-ufs-inquiry-success]")) return;
    try {
      var raw = sessionStorage.getItem(pendingKey);
      if (!raw) return;
      var pending = JSON.parse(raw);
      if (pending.path !== location.pathname || pending.expires < Date.now() ||
          typeof pending.id !== "string") {
        sessionStorage.removeItem(pendingKey);
        return;
      }
      window.fbq("trackSingle", pixelId, "Lead", {}, {eventID: pending.id});
      sessionStorage.removeItem(pendingKey);
    } catch (error) {
      return;
    }
  }

  function updateTracking() {
    if (!allowed()) {
      if (initialized) window.fbq("consent", "revoke");
      return;
    }

    if (!initialized) {
      if (!window.fbq) {
        var queue = function () {
          queue.callMethod ? queue.callMethod.apply(queue, arguments) :
            queue.queue.push(arguments);
        };
        window.fbq = queue;
        if (!window._fbq) window._fbq = queue;
        queue.push = queue;
        queue.loaded = true;
        queue.version = "2.0";
        queue.queue = [];
        var script = document.createElement("script");
        script.async = true;
        script.src = "https://connect.facebook.net/en_US/fbevents.js";
        document.head.appendChild(script);
      }
      window.fbq("consent", "grant");
      window.fbq("set", "autoConfig", false, pixelId);
      window.fbq("init", pixelId);
      initialized = true;
    } else {
      window.fbq("consent", "grant");
    }

    if (!pageViewSent) {
      window.fbq("trackSingle", pixelId, "PageView");
      pageViewSent = true;
    }
    sendCompletedInquiry();
  }

  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      updateTracking();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{name: "consent-tracking-api", version: "0.2"}], function (error) {
        if (!error) updateTracking();
      });
    }
  }

  document.addEventListener("submit", recordInquirySubmission, true);
  document.addEventListener("visitorConsentCollected", updateTracking);
  loadPrivacy();
  if (!window.Shopify || !window.Shopify.loadFeatures) {
    window.addEventListener("load", loadPrivacy, {once: true});
  }
})();
